import { MoneyRequestPaymentMethodEnum } from "../../data/Fleet/MoneyRequestPaymentMethodEnum";
import { MoneyRequestTypeEnum } from "../../data/Fleet/MoneyRequestTypeEnum";
import { RentInCompanies } from "../../data/Fleet/RentInCompanies";
import { EfsAccounts, isEfsAccount } from "../../data/Fleet/EfsAccounts";

const efsAccountField = {
  name: "efsAccount",
  label: "EFS Account",
  type: "select",
  options: EfsAccounts,
  validation: {
    required: "EFS Account is required",
    validate: (value: unknown) =>
      isEfsAccount(value) || "EFS Account must be C1 or FOX",
  },
};

export const moneyRequestFieldConfig = [
  {
    name: "truckId",
    label: "Truck Number",
    type: "combo",
    dataKey: "trucksTable",
    validation: {
      required: "Truck number is required",
    },
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
    validation: {
      required: "Driver is required",
    },
  },
  {
    name: "moneyRequestType",
    label: "Request Type",
    type: "select",
    options: MoneyRequestTypeEnum,
    validation: {
      required: "Request type is required",
    },
  },
  {
    name: "loadNumber",
    label: "Load Number",
    type: "text",
    validation: {
      required: "Load number is required",
    },
  },
  {
    name: "paymentMethod",
    label: "Payment Method",
    type: "select",
    options: MoneyRequestPaymentMethodEnum,
    validation: {
      required: "Payment method is required",
    },
  },
  efsAccountField,
  {
    name: "referenceId",
    label: "Reference ID",
    type: "text",
    validation: {
      maxLength: {
        value: 50,
        message: "Reference ID must not exceed 50 characters",
      }
    },
  },
  {
    name: "amount",
    label: "Amount",
    type: "decimal",
    validation: {
      required: "Estimated cost is required",
      pattern: {
        value: /^\d+(\.\d{1,2})?$/,
        message: "Float number separated by dot and maximum 2 decimal places",
      },
    },
  },

  {
    name: "description",
    label: "Description",
    type: "text",
    validation: {
      required: "Description is required",
      maxLength: {
        value: 150,
        message: "Description must not exceed 150 characters",
      },
    },
  },
  {
    name: "nameRequestedBy",
    label: "Requested By",
    type: "text",
    validation: { required: "Requested by is required" },
  },
  {
    name: "issuedFor",
    label: "Issued For",
    type: "select",
    options: RentInCompanies,
    validation: { required: "Issued For is required" },
  },
  {
    name: "reason",
    label: "Reason",
    type: "text",
    validation: {
      maxLength: {
        value: 150,
        message: "Reason must not exceed 150 characters",
      },
    },
    placeholder: "Why is it completed without approval?",
  },
];

export const moneyRequestFieldInitialValues = {
  driverId: "",
  truckId: "",
  amount: "",
  moneyRequestType: "",
  paymentMethod: MoneyRequestPaymentMethodEnum[0].value,
  efsAccount: "",
  referenceId: "",
  description: "",
  issuedFor: "",
  requiresApproval: false,
  completedWithoutApproval: false,
  reason: "",
  loadNumber: "",
};

export const updateMoneyRequestFieldConfig = [
  {
    name: "truckId",
    label: "Truck Number",
    type: "combo",
    dataKey: "trucksTable",
    validation: {
      required: "Truck number is required",
    },
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
    validation: {
      required: "Driver is required",
    },
  },
  {
    name: "nameRequestedBy",
    label: "Requested By",
    type: "text",
    validation: {
      required: "Requested by is required",
    },
  },
  {
    name: "amount",
    label: "Amount",
    type: "decimal",
    validation: {
      required: "Estimated cost is required",
      pattern: {
        value: /^\d+(\.\d{1,2})?$/,
        message: "Float number separated by dot and maximum 2 decimal places",
      },
    },
  },
  {
    name: "moneyRequestType",
    label: "Request Type",
    type: "select",
    options: MoneyRequestTypeEnum,
    validation: {
      required: "Request type is required",
    },
  },
  {
    name: "paymentMethod",
    label: "Payment Method",
    type: "select",
    options: MoneyRequestPaymentMethodEnum,
    validation: {
      required: "Payment method is required",
    },
  },
    {
    ...efsAccountField,
    validation: {
      validate: (value: unknown) =>
        !value || isEfsAccount(value) || "EFS Account must be C1 or FOX",
    },
  },
  {
    name: "referenceId",
    label: "Reference ID",
    type: "text",
    validation: {
      maxLength: {
        value: 50,
        message: "Reference ID must not exceed 50 characters",
      },
    },
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    validation: {
      required: "Description is required",
      maxLength: {
        value: 150,
        message: "Description must not exceed 150 characters",
      },
    },
  },
  {
    name: "issuedFor",
    label: "Issued For",
    type: "select",
    options: RentInCompanies,
    validation: { required: "Issued For is required" },
  },
];
